import React, { memo } from "react";
import { AddToNichePopup } from "./AddToNichePopup";
import { useNicheData } from "./utils/useNicheData";
import { useAddToNiche } from "@/common/queries/queries";
import { apiNiches } from "@/common/services";
import { INicheOption } from "./types";
import { IAddToNichePopupProps } from "@/common/buses/popups/popup-types";
import { onCloseAddNichePopup, onOpenAddToNicheSuccessPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { showNotification } from "@/components/alerts/Notifications";
import { AxiosError } from "axios";
import { IErrorData } from "@/common/services/types";

export const AddToNichePopupContainer: React.FC<IAddToNichePopupProps> = memo(({
  gifId
}) => {
  const addToNiche = useAddToNiche();

  const {
    nicheFields,
    suggestNicheFields,
    handleSetSuggestedNicheFiled,
    handleSetNicheFiled,
    myNichesLoading,
    gifSuggestedNichesLoading,
  } = useNicheData(gifId);

  const onClosePopup = () => {
    onCloseAddNichePopup();
  };

  const onFollowNiche = async (suggestedNiche: INicheOption) => {
    const nicheIndx = suggestNicheFields.findIndex((n) => n.id === suggestedNiche.id);
    const updatedSuggested = [...suggestNicheFields].filter((n, indx) => indx !== nicheIndx);

    try {
      await apiNiches.follow(suggestedNiche.id);

      handleSetNicheFiled([...nicheFields, suggestedNiche]);
      handleSetSuggestedNicheFiled(updatedSuggested);
      showNotification({
        title: "Joined!",
        description: "You can now add content to this Niche",
        variant: "success",
      });
    } catch {
      showNotification({
        title: "Could not change niches status",
        description: "Please try again later.",
        variant: "error",
      });
      console.error("Could not change niches status.");
    }
  };

  const onSubmit = async (niches: string[]) => {
    try {
      await addToNiche.mutateAsync({
        gifId: gifId,
        nicheIds: niches
      });
      onCloseAddNichePopup();
      onOpenAddToNicheSuccessPopup();
    } catch (err) {
      console.error("Could not set gif niches", err);
      showNotification({
        title: (err as AxiosError<IErrorData>).response?.data?.error?.message ||
        "Could not save niches, please try again",
        variant: "error"
      });
    }
  };

  return (
    <AddToNichePopup
      nicheFields={nicheFields}
      suggestNicheFields={suggestNicheFields}
      myNichesLoading={myNichesLoading}
      gifSuggestedNichesLoading={gifSuggestedNichesLoading}
      onUpdateNiches={handleSetNicheFiled}
      onClosePopup={onClosePopup}
      onSubmit={onSubmit}
      onFollowNiche={onFollowNiche}
    />
  );
});
